import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

// Fonts werden selbst gehostet (DSGVO) statt von Google/jsDelivr-CDNs geladen
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    // Signal für das Prerendering (scripts/prerender.js)
    document.dispatchEvent(new Event("x-app-rendered"));
  },
}).$mount("#app");
